<template>
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-12">
                    <np-checkbox v-if="!isView"
                                 :id="`${id}_selected`"
                                 :name="`${name}[selected]`"
                                 :no-wrapper="true"
                                 :disabled="itemIsDisabled(bundle_item)"
                                 :description="bundle_item.service.service_name"
                                 :checked="itemIsSelected(bundle_item)"
                                 @change="selectDistributionType(bundle_item)"
                                 :on-selected="function() {
                                                                      if(!bundle_item.terminal_quantity > 0 ){
                                                                        bundle_item.terminal_quantity = 1;
                                                                        bundle_item.selected = true;
                                                                        bundle_item.is_boarding_activated = '1';
                                                                      }
                                                                    }"
                                 :on-deselected="() => {bundle_item.terminal_quantity = 0; bundle_item.selected = false;
                                 bundle_item.is_boarding_activated = '0';
                            bundle_item.service_charges.forEach(obj => obj.selected = '');
                            if(objectIsNotEmpty(bundle_item.service_features)){
                              getBundleItemFeatures(bundle_item).forEach(obj => {
                              obj.selected = '';
                              obj.value = '';
                            })
                            }

                            }">
                    </np-checkbox>
                    <span v-else>   {{bundle_item.service.service_name}}</span>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <div class="marginBottom10"  v-if="itemHasDescription(bundle_item)">
                        <span class="labelLook boldText">{{lang('description')}}</span>
                        <np-show-less
                            :id="id"
                            :description="bundle_item.service.service_description" >
                        </np-show-less>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-7 col-lg-7">
                    <div class="" v-if="itemHasFeatures(bundle_item)">
<!--                        <span class="labelLook boldText">{{lang('features')}}</span>-->
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-12"
                                        v-if="featureDictionary.hasOwnProperty('distributionInfoMethod')">
                                <np-select2
                                        :label="featureDictionary.distributionInfoMethod.feature_name"
                                        :placeholder="featureDictionary.distributionInfoMethod.feature_name"
                                        :disabled="featureDictionary.distributionInfoMethod.selected !== '1' || isView"
                                        :name="`${name}_distributionInfoMethod`"
                                        :id="`${id}_distributionInfoMethod`"
                                        :key="`distributionInfoMethod`"
                                        @input="selectDistributionMode"
                                        :help-text="!!featureDictionary.distributionInfoMethod.help_text ? featureDictionary.distributionInfoMethod.help_text : ''"
                                        :parameters="getServiceFeatureList(featureDictionary.distributionInfoMethod)"
                                        v-model="featureDictionary.distributionInfoMethod.value">
                                </np-select2>
                            </div>

                            <div class="col-lg-6 col-md-6 col-12"
                                        v-if="isSelectedFeature('distributionInfoAddressType')">
                                <np-select2
                                        :label="featureDictionary.distributionInfoAddressType.feature_name"
                                        :placeholder="featureDictionary.distributionInfoAddressType.feature_name"
                                        :name="`${name}_distributionInfoAddressType`"
                                        :id="`${id}_distributionInfoAddressType`"
                                        :key="`distributionInfoAddressType`"
                                        :disabled="isView"
                                        :help-text="!!featureDictionary.distributionInfoAddressType.help_text ? featureDictionary.distributionInfoAddressType.help_text : ''"
                                        :parameters="getServiceFeatureList(featureDictionary.distributionInfoAddressType)"
                                        v-model="featureDictionary.distributionInfoAddressType.value">
                                </np-select2>
                            </div>
                        </div>
                        <np-input
                                v-if="isSelectedFeature('distributionInfoEmailAddress')"
                                :label="featureDictionary.distributionInfoEmailAddress.feature_name"
                                :placeholder="featureDictionary.distributionInfoEmailAddress.feature_name"
                                :name="`${name}_distributionInfoEmailAddress`"
                                :id="`${id}_distributionInfoEmailAddress`"
                                :key="`distributionInfoEmailAddress`"
                                :rules="['valid_email', 'required']"
                                :disabled="isView"
                                :help-text="!!featureDictionary.distributionInfoEmailAddress.help_text ? featureDictionary.distributionInfoEmailAddress.help_text : ''"
                                v-model="featureDictionary.distributionInfoEmailAddress.value">
                        </np-input>

                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5">
                    <div v-if="itemHasServiceCharges(bundle_item, isView)">
                        <span class="labelLook" style="font-weight: bold">{{lang('charges')}}</span>
                        <div class="row">
                            <template v-for="(service_charge, service_charge_idx) in bundle_item.service_charges">
                                <div class="col-12" v-if="!isView">
                                    <np-checkbox
                                            :id="`${id}_service_charge_${service_charge_idx}_selected`"
                                            :name="`${name}[service_charge][${service_charge_idx}][selected]`"
                                            :no-wrapper="true"
                                            :disabled="!bundleItemIsSelected(bundle_item)"
                                            :description="getServiceChargeDescription(service_charge)"
                                            v-model="service_charge.selected">
                                    </np-checkbox>
                                </div>
                                <div class="col-12" v-else>
                            <span>
                              {{ getServiceCharge(service_charge) }}
                              {{ service_charge.service_frequency !== '1' ? `/${formatServiceFrequency(service_charge.service_frequency)}` : '' }}
                            </span>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import utilMixin from "../utils/mixins";
    import applicationMixin from "../utils/application-mixin";
    import equipmentMixin from "../utils/equipment-mixin";
    import {Multiselect} from 'vue-multiselect';
    import {
        NPCheckBox,
        NPEntry,
        NPInput,
        NPNotice, NPPhone,
        NPRadios,
        NPResponsive,
        NPSelect2,
        NPSkeleton, NPShowLess

    } from "netpify/components";
    import NpMultiselect from "netpify/components/np-multiselect.vue";

    export default {
        name: "equipment-service-distribution",
        mixins: [utilMixin, applicationMixin, equipmentMixin],
        components: {
            'np-multiselect': NpMultiselect,
            'np-entry': NPEntry,
            'multiselect': Multiselect,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-select2': NPSelect2,
            'np-responsive': NPResponsive,
            'np-skeleton': NPSkeleton,
            'np-checkbox': NPCheckBox,
            'np-notice': NPNotice,
            'np-phone': NPPhone,
            'np-show-less': NPShowLess,
        },
        data() {
            return {
                addressTypes: {
                    'BRANCH_FAX': 'BRANCH_FAX',
                    'BUSINESS': 'BUSINESS',
                    'CHARGEBACK': 'CHARGEBACK',
                    'ELECTRONIC': 'ELECTRONIC',
                    'EMAIL': 'EMAIL',
                    'FAX': 'FAX',
                    'MAIL': 'MAIL',
                    'MAILING': 'MAILING',
                    'MAILING_AND_FAX': 'MAILING_AND_FAX',
                    'NONE': 'NONE',
                    'SHIPPING': 'SHIPPING',
                },
                featureList: [],
            }
        },
        props: {
            bundle_item: {
                default() {
                    return {}
                }
            },
            isStandalone: Boolean,
            id: {
                default() {
                    return 'quote' + Math.random().toString()
                }
            },
            name: {
                default() {
                    return 'quote' + Math.random().toString()
                }
            },
            feature_dictionary: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            isView: Boolean,
            isBundlePackage: Boolean,
            bundlePackageSelected: Boolean,
        },
        mounted() {
            this.featureList = this.getBundleItemFeatures(this.bundle_item);
        },
        computed: {
            totalSellingOptions: function () {
                let total = 0.00;

                if (this.objectIsNotEmpty(this.bundle_item.service_charges)) {
                    let selected_service_charges = this.bundle_item.service_charges.filter(obj => obj.selected === '1');

                    selected_service_charges.forEach(obj => {
                        if (obj.service_frequency === '1') {
                            let value = !!obj.default_base_charge && obj.default_base_charge !== '' ? obj.default_base_charge :
                                !!obj.maximum_base_charge && obj.maximum_base_charge !== '' ? obj.maximum_base_charge : 0.00;
                            total = parseFloat(total) + parseFloat(value)
                        }
                    })
                }

                return this.convertToDecimal(total);
            },
            featureDictionary: function () {
                let feature_dictionary = {};
                this.featureList.forEach(feature => {
                    feature_dictionary[feature['feature_api_code']] = feature;
                });
                return feature_dictionary;
            },
            featureListValuesDictionary: function () {
                // let featureListValues = Object.values(this.parameters['FEATURE_LIST_OF_LISTS_VALUES_PARAM']).find(obj => {
                //     return obj['feature_list_value_external_id'] === pciContact
                // });
                let feature_lists = this.parameters['FEATURE_LIST_OF_LISTS_VALUES_PARAM'];
                let featureListValues = Object.fromEntries(
                    Object.entries(feature_lists)
                        .map(([key, val]) => [val['feature_list_value_external_id'], val])
                );
                return featureListValues;
            }
        },
        methods: {
            itemHasDescription: function (bundle_item) {
                return bundle_item.service.hasOwnProperty('service_description') &&
                    bundle_item.service.service_description !== '';
            },
            itemIsDisabled: function (bundle_item) {
                return this.isView ? true : this.isBundlePackage ? true : this.equipmentIsDisabled(bundle_item);
            },
            selectDistributionType: function (bundle_item) {
                if(!bundle_item.terminal_quantity > 0 ){
                    bundle_item.terminal_quantity = 1
                    bundle_item.selected = true;
                    bundle_item.is_boarding_activated = '1'
                }
                if (!!this.statementType) {
                    this.featureDictionary[this.statementFeatureApiCode]['selected'] = '1';
                }
                if (this.featureDictionary.hasOwnProperty('distributionInfoMethod')) {
                    this.featureDictionary['distributionInfoMethod']['selected'] = '1'
                }
            },
            prepFeatureDictionary: function (bundle_item) {
                let bundle_item_features = this.getBundleItemFeatures(bundle_item);
                let feature_dictionary = {};
                bundle_item_features.forEach(feature => {
                    feature_dictionary[feature['feature_api_code']] = feature;
                });
                return feature_dictionary;
            },
            isSelectedFeature: function (feature_api_code) {
                if (this.featureDictionary.hasOwnProperty(feature_api_code) && this.featureDictionary[feature_api_code]['selected'] === '1') {
                    return true;
                }
                return false;
            },
            selectDistributionMode: function () {
                //if pciContact is pre-populate
                let distributionInfoMethod = this.featureDictionary.distributionInfoMethod.value;
                let distributionInfoMethodListValue = this.featureListValuesDictionary[distributionInfoMethod];
                if (distributionInfoMethodListValue['value'] === this.addressTypes.EMAIL || distributionInfoMethodListValue['value'] === this.addressTypes.ELECTRONIC) {
                    if (this.featureDictionary.hasOwnProperty('distributionInfoEmailAddress')) {
                        this.featureDictionary.distributionInfoEmailAddress['selected'] = '1';
                    }
                    if (this.featureDictionary.hasOwnProperty('distributionInfoAddressType')) {
                        this.featureDictionary.distributionInfoAddressType['selected'] = '';
                        this.featureDictionary.distributionInfoAddressType['value'] = '';
                    }
                }
                if (distributionInfoMethodListValue['value'] !== this.addressTypes.EMAIL && distributionInfoMethodListValue['value'] !== this.addressTypes.ELECTRONIC) {
                    if (this.featureDictionary.hasOwnProperty('distributionInfoAddressType')) {
                        this.featureDictionary.distributionInfoAddressType['selected'] = '1';
                    }
                    if (this.featureDictionary.hasOwnProperty('distributionInfoEmailAddress')) {
                        this.featureDictionary.distributionInfoEmailAddress['selected'] = '';
                        this.featureDictionary.distributionInfoEmailAddress['value'] = '';
                    }
                }
            },
            itemIsSelected: function (bundle_item) {
                return this.isBundlePackage ? this.bundlePackageSelected ? '1' : '0' : this.equipmentIsSelected(bundle_item);
            },
            getServiceChargeDescription: function (service_charge) {
                return service_charge.service_item_name + ' - ' + this.getServiceCharge(service_charge) + (service_charge.service_frequency !== '1' ? `/${this.formatServiceFrequency(service_charge.service_frequency)}` : '');
            },
            getFeatureValue: function (feature) {
                let feature_value = !!feature.value ? feature.value : feature.default_value

                if (feature.feature_input_type === this.types.LIST) {
                    let feature_list = this.getFeatureList(feature);
                    let matched_value = feature_list.find(obj => obj.id === feature_value);

                    return !!matched_value ? `(${matched_value.text})` : '';
                } else {
                    return feature_value !== '' ? `(${feature_value})` : '';
                }
            }
        }
    }
</script>

<style scoped>
    ul:not(.nav-pills) {
        list-style: none;
    }

    li:not(.nav-item) {
        font-weight: lighter;
        font-size: 0.8em;
    }

    li:not(.nav-item):before {
        content: "\f054"; /* FontAwesome Unicode fa-chevron-right*/
        font-family: 'Font Awesome 5 Free';
        font-weight: 900;
        display: inline-block;
        margin-left: -1.3em; /* same as padding-left set on li */
        width: 1.3em; /* same as padding-left set on li */
    }

    /*.avatar-small:hover {*/
    /*    box-shadow: 0 0 2px 1px rgba(66, 153, 225, 1);*/
    /*    -ms-transform: scale(2.5); !* IE 9 *!*/
    /*    -webkit-transform: scale(2.5); !* Safari 3-8 *!*/
    /*    transform: scale(2.5);*/
    /*    cursor: pointer;*/
    /*    z-index: 99999;*/
    /*}*/

    .vue-radio-checkbox.np-checkbox.default.form-group {
        min-height: 0 !important;
    }


</style>
